var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.loading
          ? _c("div", { staticClass: "spinner-overlay" }, [_vm._m(1)])
          : _vm._e(),
        _vm._v(" "),
        _c("fieldset", { staticClass: "border p-2" }, [
          _c("legend", { staticClass: "w-auto" }, [
            _vm._v("Filtro de Búsqueda")
          ]),
          _vm._v(" "),
          _c("form", [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "period" } }, [
                    _vm._v("Periodo ")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.period,
                        expression: "period"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "period",
                      placeholder: "YYYYMM",
                      required: ""
                    },
                    domProps: { value: _vm.period },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.period = $event.target.value
                        },
                        _vm.onPeriodChange
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.periodErrorMessage
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.periodErrorMessage))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "idLiquidacion" } }, [
                    _vm._v(" ID de Liquidación")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.idLiquidacion,
                        expression: "idLiquidacion"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "idLiquidacion" },
                    domProps: { value: _vm.idLiquidacion },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.idLiquidacion = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: " RUT Beneficiario" } }, [
                    _vm._v(" RUT Beneficiario")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.beneficiaryID,
                        expression: "beneficiaryID"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.beneficiaryIDError },
                    attrs: {
                      type: "text",
                      id: "beneficiaryID",
                      placeholder: "XXXXXXXX-X"
                    },
                    domProps: { value: _vm.beneficiaryID },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.beneficiaryID = $event.target.value
                        },
                        function($event) {
                          return _vm.formatRut("beneficiaryID")
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.beneficiaryIDError
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v("Rut inválido")
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { attrs: { for: "¿CSV Notificación fecha pago?" } },
                    [_vm._v(" ¿CSV Notificación fecha pago?")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csvPaymentDateNotification,
                            expression: "csvPaymentDateNotification"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "csvPaymentDateNotification" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.csvPaymentDateNotification = $event.target
                              .multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("Sí")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("NO")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.csvPaymentDateNotification !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.csvPaymentDateNotification = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "¿Cargado IPS?" } }, [
                    _vm._v(" ¿Cargado IPS?")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ipsLoaded,
                            expression: "ipsLoaded"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "ipsLoaded" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.ipsLoaded = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: 1 } }, [
                          _vm._v("Sí")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 2 } }, [
                          _vm._v("NO")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 0 } }, [
                          _vm._v("ERROR")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ipsLoaded !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.ipsLoaded = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "processBatchId" } }, [
                    _vm._v("ID Batch ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedProcessBatchId,
                            expression: "selectedProcessBatchId"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "selectedProcessBatchId" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProcessBatchId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.processBatchIds, function(batch) {
                        return _c(
                          "option",
                          { key: batch, domProps: { value: batch } },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(batch) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.selectedProcessBatchId !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.selectedProcessBatchId = null
                                }
                              }
                            },
                            [_vm._v(" ✕\n                    ")]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.processBatchError
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.processBatchError))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "RUT Cliente" } }, [
                    _vm._v(" RUT Cliente")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.customerID,
                        expression: "customerID"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.customerIDError },
                    attrs: {
                      type: "text",
                      id: "customer-id",
                      placeholder: "XXXXXXXX-X"
                    },
                    domProps: { value: _vm.customerID },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.customerID = $event.target.value
                        },
                        function($event) {
                          return _vm.formatRut("customerID")
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.customerIDError
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v("Rut inválido")
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "¿Beneficio IPS?" } }, [
                    _vm._v("¿Beneficio IPS?")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isPGU,
                            expression: "isPGU"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "isPGU" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.isPGU = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("Sí")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("NO")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isPGU !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.isPGU = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "¿Renderizado?" } }, [
                    _vm._v(" ¿Renderizado?")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isRendered,
                            expression: "isRendered"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "isRendered" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.isRendered = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "Success" } }, [
                          _vm._v("Sí")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "NotRendered" } }, [
                          _vm._v("NO")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Failed" } }, [
                          _vm._v("ERROR")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isRendered !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.isRendered = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "small",
                      attrs: {
                        for:
                          "¿CSV Notificación Comprobante de\n                    Pago?"
                      }
                    },
                    [
                      _vm._v(
                        " ¿CSV Notificación Comprobante de\n                  Pago?"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csvPaymentProofNotification,
                            expression: "csvPaymentProofNotification"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "csvPaymentProofNotification" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.csvPaymentProofNotification = $event.target
                              .multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("Sí")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("NO")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.csvPaymentProofNotification !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.csvPaymentProofNotification = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "processType" } }, [
                    _vm._v("Tipo de Proceso")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.processType,
                            expression: "processType"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "processType" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.processType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "Standard" } }, [
                          _vm._v("Estándar")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "ReProcess" } }, [
                          _vm._v("Reproceso")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.processType !== null
                      ? _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.processType = null
                                }
                              }
                            },
                            [_vm._v(" ✕ ")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "form-group button-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right mr-2",
                      attrs: {
                        type: "button",
                        disabled: _vm.periodErrorMessage || _vm.period === ""
                      },
                      on: { click: _vm.search }
                    },
                    [_vm._v("\n                  Buscar\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right mr-2",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        "data-target": "#confirmationModal",
                        disabled:
                          _vm.periodErrorMessage ||
                          _vm.period === "" ||
                          _vm.adminProcessingSummary.length === 0
                      }
                    },
                    [_vm._v("\n                  Reprocesar\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right mr-2",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.periodErrorMessage ||
                          _vm.period === "" ||
                          !_vm.adminProcessingSummary ||
                          _vm.adminProcessingSummary.length === 0
                      },
                      on: { click: _vm.exportSelectionCVS }
                    },
                    [
                      _vm._v(
                        "\n                  Exportar selección\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right mr-2",
                      attrs: { type: "button", disabled: !_vm.period },
                      on: { click: _vm.clearData }
                    },
                    [
                      _vm._v(
                        "\n                  Limpiar Filtros\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal fade",
                      attrs: {
                        id: "confirmationModal",
                        tabindex: "-1",
                        role: "dialog",
                        "aria-labelledby": "confirmationModalLabel"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "modal-dialog modal-dialog-centered",
                          attrs: { role: "document" }
                        },
                        [
                          _c("div", { staticClass: "modal-content" }, [
                            _c("fieldset", { staticClass: "border m-3" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("div", { staticClass: "modal-body" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-9 mx-auto my-3" },
                                    [
                                      _c(
                                        "table",
                                        { staticClass: "custom-table" },
                                        [
                                          _c("tr", [
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "form-check" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm
                                                            .ReprocessOptionValue[
                                                            "CSV Notificación fecha pago"
                                                          ],
                                                        expression:
                                                          "ReprocessOptionValue['CSV Notificación fecha pago']"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      value:
                                                        "CSV Notificación fecha pago",
                                                      id:
                                                        "CSVNotificaciónfechapago"
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm
                                                          .ReprocessOptionValue[
                                                          "CSV Notificación fecha pago"
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "CSV Notificación fecha pago"
                                                            ],
                                                            "CSV Notificación fecha pago"
                                                          ) > -1
                                                        : _vm
                                                            .ReprocessOptionValue[
                                                            "CSV Notificación fecha pago"
                                                          ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "CSV Notificación fecha pago"
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              "CSV Notificación fecha pago",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "CSV Notificación fecha pago",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "CSV Notificación fecha pago",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.ReprocessOptionValue,
                                                            "CSV Notificación fecha pago",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for:
                                                          "CSVNotificaciónfechapago"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        CSV Notificación Fecha Pago\n                                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "form-check" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm
                                                            .ReprocessOptionValue[
                                                            "Renderizado"
                                                          ],
                                                        expression:
                                                          "ReprocessOptionValue['Renderizado']"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      value: "Renderizado",
                                                      id: "Renderizado"
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm
                                                          .ReprocessOptionValue[
                                                          "Renderizado"
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "Renderizado"
                                                            ],
                                                            "Renderizado"
                                                          ) > -1
                                                        : _vm
                                                            .ReprocessOptionValue[
                                                            "Renderizado"
                                                          ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "Renderizado"
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              "Renderizado",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "Renderizado",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "Renderizado",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.ReprocessOptionValue,
                                                            "Renderizado",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "Renderizado"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        Renderizado Link\n                                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "form-check" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm
                                                            .ReprocessOptionValue[
                                                            "CSV Notificación comprobante pago"
                                                          ],
                                                        expression:
                                                          "ReprocessOptionValue['CSV Notificación comprobante pago']"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      value:
                                                        "CSV Notificación comprobante pago",
                                                      id:
                                                        "CSVNotificaciónComprobantePago"
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm
                                                          .ReprocessOptionValue[
                                                          "CSV Notificación comprobante pago"
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "CSV Notificación comprobante pago"
                                                            ],
                                                            "CSV Notificación comprobante pago"
                                                          ) > -1
                                                        : _vm
                                                            .ReprocessOptionValue[
                                                            "CSV Notificación comprobante pago"
                                                          ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "CSV Notificación comprobante pago"
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              "CSV Notificación comprobante pago",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "CSV Notificación comprobante pago",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "CSV Notificación comprobante pago",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.ReprocessOptionValue,
                                                            "CSV Notificación comprobante pago",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for:
                                                          "CSVNotificaciónComprobantePago"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        CSV Notificación Comprobante Pago\n                                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c(
                                                "div",
                                                { staticClass: "form-check" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm
                                                            .ReprocessOptionValue[
                                                            "Carga IPS"
                                                          ],
                                                        expression:
                                                          "ReprocessOptionValue['Carga IPS']"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      value: "Carga IPS",
                                                      id: "CargaIPS",
                                                      disabled:
                                                        _vm.isPGU === false
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm
                                                          .ReprocessOptionValue[
                                                          "Carga IPS"
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "Carga IPS"
                                                            ],
                                                            "Carga IPS"
                                                          ) > -1
                                                        : _vm
                                                            .ReprocessOptionValue[
                                                            "Carga IPS"
                                                          ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm
                                                              .ReprocessOptionValue[
                                                              "Carga IPS"
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = "Carga IPS",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "Carga IPS",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.ReprocessOptionValue,
                                                                "Carga IPS",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.ReprocessOptionValue,
                                                            "Carga IPS",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "CargaIPS" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        Cargar en IPS\n                                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-9 mx-auto my-3" },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "userComment" } },
                                        [_vm._v("Comentario:")]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userComment,
                                            expression: "userComment"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "userComment",
                                          placeholder:
                                            "Ingrese su comentario aquí...",
                                          rows: "3"
                                        },
                                        domProps: { value: _vm.userComment },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.userComment =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal"
                                    }
                                  },
                                  [_vm._v("Cancelar")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      "data-target": "#optionModal",
                                      "data-toggle": "modal",
                                      "data-dismiss": "modal",
                                      disabled:
                                        !_vm.isAnyOptionSelected ||
                                        !_vm.userComment
                                    }
                                  },
                                  [_vm._v("Confirmar")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal",
                      attrs: {
                        id: "optionModal",
                        "aria-labelledby": "optionModalLabel",
                        tabindex: "-1"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "modal-dialog modal-dialog-centered modal-lg"
                        },
                        [
                          _c("div", { staticClass: "modal-content" }, [
                            _c("fieldset", { staticClass: "border m-3" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("div", { staticClass: "modal-body" }, [
                                _vm._v(
                                  "\n                          ¿Está seguro que desea reprocesar el renderizado según los siguientes filtros?\n                          "
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 mx-auto my-3" },
                                  [
                                    _c("div", { staticClass: "table-grid" }, [
                                      _vm.period
                                        ? _c("div", [
                                            _c("strong", [_vm._v("Periodo:")]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.period))
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.idLiquidacion
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("ID de Liquidación:")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.idLiquidacion))
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.beneficiaryID
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("RUT Beneficiario:")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.beneficiaryID))
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.csvPaymentDateNotification !== null
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                "¿CSV Notificación fecha pago?"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.csvPaymentDateNotification
                                                    ? "SI"
                                                    : "NO"
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.ipsLoaded !== null
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("¿Cargado IPS?")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ipsLoaded === 1
                                                    ? "SI"
                                                    : _vm.ipsLoaded === 0
                                                    ? "NO"
                                                    : _vm.ipsLoaded === 2
                                                    ? "ERROR"
                                                    : _vm.ipsLoaded
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedProcessBatchId
                                        ? _c("div", [
                                            _c("strong", [_vm._v("ID Batch:")]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedProcessBatchId
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customerID
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("RUT Cliente:")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.customerID))
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isPGU !== null
                                        ? _c("div", [
                                            _c("strong", [_vm._v("¿PGU?")]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.isPGU ? "SI" : "NO")
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isRendered
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v("¿Renderizado?")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isRendered === "Success"
                                                    ? "SI"
                                                    : _vm.isRendered ===
                                                      "NotRendered"
                                                    ? "NO"
                                                    : _vm.isRendered ===
                                                      "Failed"
                                                    ? "ERROR"
                                                    : _vm.isRendered
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.csvPaymentProofNotification !== null
                                        ? _c("div", [
                                            _c("strong", [
                                              _vm._v(
                                                "¿CSV Notificación Comprobante de Pago?"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.csvPaymentProofNotification
                                                    ? "SI"
                                                    : "NO"
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("table", { staticClass: "table" }, [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v("Opciones Seleccionadas ")
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "ul",
                                            _vm._l(
                                              _vm.ReprocessOptionValue,
                                              function(value, key) {
                                                return value
                                                  ? _c("li", { key: key }, [
                                                      _vm._v(
                                                        "\n                                      " +
                                                          _vm._s(key) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  : _vm._e()
                                              }
                                            ),
                                            0
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("table", { staticClass: "table" }, [
                                      _c("tr", [
                                        _c("th", [_vm._v("Nombre")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(_vm.userName))
                                        ]),
                                        _vm._v(" "),
                                        _vm.userComment
                                          ? _c("th", [_vm._v("Comentario")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(_vm.userComment))
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal"
                                    }
                                  },
                                  [_vm._v("Cancelar")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-target": "#confirmationModal",
                                      "data-toggle": "modal",
                                      "data-dismiss": "modal"
                                    },
                                    on: { click: function($event) {} }
                                  },
                                  [_vm._v("Volver")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      "data-dismiss": "modal",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: _vm.triggerReprocessStepfunction
                                    }
                                  },
                                  [_vm._v("Continuar")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.adminProcessingSummary && _vm.adminProcessingSummary.length
          ? _c("fieldset", { staticClass: "border p-2" }, [
              _c("legend", { staticClass: "w-auto" }, [
                _vm._v("Resumen Procesamiento ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "table-container" }, [
                    _c("table", { staticClass: "table table-striped" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(_vm.adminProcessingSummaryHeading, function(
                            item
                          ) {
                            return _c(
                              "th",
                              { key: item.name, staticClass: "small" },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        {
                          staticStyle: { height: "300px", "overflow-y": "auto" }
                        },
                        _vm._l(_vm.adminProcessingSummary, function(process) {
                          return _c(
                            "tr",
                            {
                              key:
                                process.idLiquidacion +
                                "-" +
                                process.batchId +
                                "-" +
                                process.startTime
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.formatString(process.startTime))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(process.periodo))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(process.idLiquidacion))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(process.batchId))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(process.rutCliente))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(process.rutBeneficiario))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.formatField(process.pgu)))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatString(
                                      process.csvPaymentDateNotification
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.formatString(process.renderStatus))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.formatString(process.processType))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.formatString(process.errorReason))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(process.ipsLoaded))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatString(
                                      process.csvPaymentProofNotification
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "nav",
                    { attrs: { "aria-label": "Page navigation example" } },
                    [
                      _c(
                        "ul",
                        { staticClass: "pagination justify-content-end" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group btn-group-sm my-2",
                              attrs: {
                                role: "group",
                                "aria-label": "Basic example"
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn page-link px-3 large-symbol",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.currentPage === 1
                                  },
                                  on: { click: _vm.firstPage }
                                },
                                [_vm._v("«")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn page-link px-3 large-symbol",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.currentPage === 1
                                  },
                                  on: { click: _vm.prevPage }
                                },
                                [_vm._v("‹")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn page-item px-3 p-2",
                                  attrs: { type: "button" }
                                },
                                [
                                  _vm._v(
                                    "Page " +
                                      _vm._s(_vm.currentPage) +
                                      " of " +
                                      _vm._s(_vm.totalPages)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn page-link px-3 large-symbol",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.currentPage === _vm.totalPages
                                  },
                                  on: { click: _vm.nextPage }
                                },
                                [_vm._v("›")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn page-link px-3 large-symbol",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.currentPage === _vm.totalPages
                                  },
                                  on: { click: _vm.lastPage }
                                },
                                [_vm._v("»")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "card-header p-2 text-center bg-primary text-white" },
      [
        _c("h4", [
          _vm._v("Administrador Proceso Comprobante de Pago de Pensión")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("legend", { staticClass: "w-auto" }, [
        _vm._v("¿Cúal flujo quiere reprocesar?")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("legend", { staticClass: "w-auto" }, [_vm._v("Confirmar Reproceso")]),
      _vm._v(" "),
      _c("h5", {
        staticClass: "modal-title fs-5",
        attrs: { id: "optionModalLabel" }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3446f44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3446f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative.vue
// module id = null
// module chunks = 